import { IDate } from "../../../models"

export interface IOTEmployee {
    Id: string
    PunchInId: string
    UserName: string
    UserExternalId: string
    ProfileImageID: string
    ProfileImageS3Url: string
    DefaultHierarchyItemId: string
    DefaultPunchHierarchyId: string
    SupervisorIds: string[]
    TotalProductive: number
    Reg: number
    OT: number
    OT2: number
    PunchInTime: IDate
    EstimatedTotal: number
}

export enum EOTEmployeeType {
    ApproachingOT,
    OT
}